import React, { useEffect, useState } from 'react'
import {
  Card, CardContent, Typography, Box,
  Container, Stack, Tooltip, LinearProgress, IconButton, DialogContentText, DialogTitle,
  TextField, Select, MenuItem, Checkbox,
} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import CustomizedTables from './dataTable'
import { useNavigate, useParams } from "react-router-dom";
import { IOrderBoxes, IOrderHeader } from '../../interface/IOrders_Tasks';
import { IShipmentClientRes, IUser } from '../../interface/IUser';
import '../../App.css'
import { useSelector } from 'react-redux';
import { ITaskStatus } from '../../interface/ITask';
import { AxiosInstance } from '../../api/apiInstance';
import PackedBoxesTable from './PackedBoxesTable';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CameraDialog from '../camera/CameraDialog';
//import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import SaveIcon from '@mui/icons-material/Save';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import Barcode from 'react-barcode';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ForwardIcon from '@mui/icons-material/Forward';
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone';
import { CardTitle } from 'react-bootstrap';
import OrderBaskets from './orderBaskets';
import OrderChat from './orderChat';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShipRushDialog from './ShipRushDialog';
import SvgLg from './ShipRushLogo';
 import logoShipRush from '../../assests/lg.svg';
 


function OrderLines() {
  const userinfo: IUser = useSelector((state: any) => state.user)
  const taskStatus: ITaskStatus[] = useSelector((state: any) => state.taskStatus)
  const navigate = useNavigate();
  let { orderData } = useParams();
  const [allitemsCount, setAllitemsCount] = useState(0);
  const [singleOrderData, setSingleOrderData] = useState<IOrderHeader>({} as IOrderHeader);
  const [takePicture, setTakePicture] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const [boxCount, setBoxCount] = useState(0);
  const [url, setUrl] = useState<string | null>(null);
  const [allowEdit, setAllowEdit] = React.useState(false);
  const [allowEditAlertText, setAllowEditAlertText] = React.useState('');
  const TaskUsers: IUser[] = useSelector((state: any) => state.allUsers)
  const [newAssign, setNewAssign] = useState(1);
  const [openShipRush, setOpenShipRush] = useState<boolean>(false);
  const [ShipRushDialogTitle, setShipRushDialogTitle] = useState('ShipRush');
  const [shipRushRes, setShipRushRes] = useState<IShipmentClientRes>({
    isSuccess: 'Pending',
    ShipmentId: '',
    ShipmentNumber: 'Pending',
    messages: [{ Severity: '', textMessage: '' }],
    printLables: [{ dataLabel: '' }],
  });


  const handleClickOpenCamera = () => {
    setTakePicture(true);
  };

  useEffect(() => {
    if (userinfo.userRoleName === 'Administrator') {
      setAllowEdit(false);
      setAllowEditAlertText('Please assign role');
    }
    else {
      if (singleOrderData?.taskStatus?.status === 'New') {
        setAllowEdit(false);
        setAllowEditAlertText('Please click in progress');
      }
      else {
        setAllowEdit(true);
        setAllowEditAlertText('');
      }
    }
  }, [userinfo.userRoleName, singleOrderData?.taskStatus?.status]);




  useEffect(() => {
    if (url === '') return;
    if (singleOrderData.orderPhotoBase64 === null) {
      singleOrderData.orderPhotoBase64 = url;
    }
    else {
      if (singleOrderData.orderPhotoBase64_1 === null) {
        singleOrderData.orderPhotoBase64_1 = url;
      }
      else {
        singleOrderData.orderPhotoBase64_2 = url;
      }
    }
    setSingleOrderData(singleOrderData);
  }, [url])


  async function UpdateOrderChangeShipper() {
    // const tmpOrder = { ...singleOrderData }
    // tmpOrder.user.id = newAssign;
    // await AxiosInstance.patch('order/' + singleOrderData.id, tmpOrder)
    //   .then(function (response) {

    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });

    const setUser =
    {
      user: { id: newAssign }
    }
    await AxiosInstance.patch('order/updateData/' + singleOrderData.id, setUser)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    navigate('/orders')

  }

  async function SendToShipPrioritySh() {

    setShipRushRes({
      isSuccess: 'Pending',
      ShipmentNumber: 'Pending',
      ShipmentId: '',
      messages: [{ Severity: 'Pending', textMessage: '' }],
      printLables: [],
    });
    setShipRushDialogTitle('Priority')
    setOpenShipRush(true);

    const res = await AxiosInstance.patch('get-order-info/createPrioritySh/' + singleOrderData.id)
      .then(function (response) {
        const res = response.data as unknown as IShipmentClientRes;
        console.log(res)
        setShipRushRes({
          isSuccess: res.isSuccess,
          ShipmentNumber: res.ShipmentNumber || '',
          ShipmentId: '',
          messages: res.messages,
          printLables: res.printLables,
        });
        const tmpOrder = { ...singleOrderData }
        tmpOrder.ShData = res.ShipmentNumber;
        setSingleOrderData(tmpOrder);
      })
      .catch(function (error) {
        console.log(error);
        setShipRushRes({
          isSuccess: 'Error',
          ShipmentNumber: 'Error',
          ShipmentId: '',
          messages: [{ Severity: 'Error', textMessage: error.response.data.error + ': ' + error.response.data.message }],
          printLables: [],
        });
      });



  }

  async function SendToShipRush() {

    setShipRushRes({
      isSuccess: 'Pending',
      ShipmentNumber: 'Pending',
      ShipmentId: '',
      messages: [{ Severity: 'Pending', textMessage: '' }],
      printLables: [],
    });
    setShipRushDialogTitle('ShipRush')
    setOpenShipRush(true);
    const res = await AxiosInstance.patch('get-order-info/createShipRushDelivery/' + singleOrderData.id)
      .then(function (response) {
        const res = response.data as unknown as IShipmentClientRes;
        console.log(res)
        setShipRushRes({
          isSuccess: res.isSuccess,
          ShipmentNumber: res.ShipmentNumber || '',
          ShipmentId: '',
          messages: res.messages,
          printLables: res.printLables,
        });
        const tmpOrder = { ...singleOrderData }
        tmpOrder.ShData = res.ShipmentNumber;
        setSingleOrderData(tmpOrder);
      })
      .catch(function (error) {
        console.log(error);
        setShipRushRes({
          isSuccess: 'Error',
          ShipmentNumber: 'Error',
          ShipmentId: '',
          messages: [{ Severity: 'Error', textMessage: error.response.data.error + ': ' + error.response.data.message }],
          printLables: [],
        });
      });



  }
  async function UpdateOrder(statusOrder: number, refreshRequired: boolean) {
    const tmpOrder = { ...singleOrderData }
    let isNetError = false;
    if (userinfo.userRoleName === 'Administrator') {

      const alertMessage = 'Please assign role';
      window.alert(alertMessage)
      return;
    }

    if (userinfo.userRoleName === 'Packer' && statusOrder === 5) {
      if (boxCount === 0) {
        const alertMessage = 'No boxes added, Are you sure you want to Continue ?';
        if (!window.confirm(alertMessage)) {
          return;
        }
      }
    }
    if (userinfo.userRoleName === 'Shipper' && statusOrder === 5) {
      if (tmpOrder.ShData?.length === 0 || tmpOrder.ShData === null) {
        const alertMessage = 'Sh number is Required';
        window.alert(alertMessage)
        return;
      }
    }


    if (userinfo.userRoleName === 'QC' && statusOrder === 5) {
      const fullfilledShiperApproved = tmpOrder.orderLines.filter((ol) => {
        if (ol.approved === false) return true;
      })
      if (fullfilledShiperApproved?.length > 0) {
        const alertMessage = 'Please approve all lines';
        window.alert(alertMessage)
        return;

      }
    }


    const fullfilledErrorQC = tmpOrder.orderLines.filter((ol) => {
      if (ol.TBALANCE !== ol.FullfilledSuperViser) return true; else return false;
    })

    if (fullfilledErrorQC?.length > 0 && statusOrder === 5 && userinfo.userRoleName === 'QC') {
      const borcodes = fullfilledErrorQC.map((ol) => {
        return ol.PARTNAME + " - "
      });

      const alertMessage = 'Inavlid quantities for items:' + borcodes.join() + ' Are you sure you want to Continue ?'
      if (!window.confirm(alertMessage)) {
        return;
      }
    }

    const fullfilledError = tmpOrder.orderLines.filter((ol) => {
      if (ol.TBALANCE !== ol.Fullfilled) return true;
    })
    if (fullfilledError?.length > 0 && statusOrder === 5 && userinfo.userRoleName === 'Picker') {
      const borcodes = fullfilledError.map((ol) => {
        return ol.PARTNAME + " - "
      });

      const alertMessage = 'Inavlid quantities for items:' + borcodes.join() + ' Are you sure you want to Continue ?'
      if (!window.confirm(alertMessage)) {
        return;
      }
    }
    tmpOrder.role.id = userinfo.userRoleId;
    tmpOrder.user.id = userinfo.id;
    tmpOrder.taskStatus = { id: statusOrder, status: '', color: 'grey' };
    await AxiosInstance.patch('order/' + singleOrderData.id, tmpOrder)
      .then(function (response) { })
      .catch(function (error) {
        isNetError = true;
        alert(error.response.data.message);
        //navigate('/orders');
      });
    if (isNetError) return
    if (statusOrder !== 2)
      navigate('/orders')
    else
      if (refreshRequired)
      {
        await GetSingleOrder();
      }
      

  }
  async function GetSingleOrder() {
    const ord = await AxiosInstance({
      // url of the api endpoint (can be changed)
      url: "order/" + orderData,
      method: "GET",
    }).then((res) => {
      // handle success
      const tmpRes: IOrderHeader = res.data;
      if (tmpRes.user.id !== 1) {
        if (tmpRes.user.id !== userinfo.id && userinfo.userRoleName !== 'Administrator') {
          const alertMessage = 'Order assigned to another user';
          window.alert(alertMessage)
          navigate('/orders')
          return;
        }
      }
      return tmpRes;
    });
    ord?.orderLines.forEach(element => {
      element.qtyFieldDisabled = false;

    });
    setSingleOrderData(ord);
    setShowSpinner(false);
  }

  useEffect(() => {
    GetSingleOrder();
  }, [])


  useEffect(() => {
    const initialValue = 0;
    let sumWithInitial = singleOrderData?.orderLines?.reduce(
      (sumWithInitial, ol) => sumWithInitial + ol.TBALANCE,
      initialValue,
    );
    //let allCount = singleOrderData.orderLines.reduce((allCount , ol.)=> allCount + ol.TBALANCE ,0);
    setAllitemsCount(sumWithInitial)
  }, [singleOrderData])

  async function _handleShDataChange(e: any) {
    const tmpOrder = { ...singleOrderData }
    tmpOrder.ShData = e.target.value;
    setSingleOrderData(tmpOrder);
  }
  async function _handlePalletChange(e: any) {
    const tmpOrder = { ...singleOrderData }
    if (e.target.checked === undefined)
      tmpOrder.Pallet = false;
    else
      tmpOrder.Pallet = !tmpOrder.Pallet;
    console.log('_handlePalletChange', e.target.checked, tmpOrder.Pallet);
    setSingleOrderData(tmpOrder);
  }


  return (
    <Container component="main"  >

      {/* {takePicture ? <CameraDialog
        openCam={takePicture}
        setTakePicture={setTakePicture}
        url={url}
        setUrl={setUrl}
      /> : <></>} */}
      <ShipRushDialog
        open={openShipRush}
        ShipRushResult={shipRushRes}
        onClose={setOpenShipRush}
        Title={ShipRushDialogTitle} />
      <Box

        //my={2}
        display="flex"
        flexDirection={"column"}
        alignItems="center"
        gap={2}
        p={2}
        m={2}
        borderRadius={"1rem"}
        bgcolor={"#f6eeee"}
        boxShadow={1}>
        <Stack direction={'row'} spacing={2}>
          <Card sx={{ maxWidth: 645 }}>

            <CardContent>
              <Typography gutterBottom variant="body2" component="div">
                Order: {singleOrderData?.ORDNAME}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <Barcode displayValue={false} width={1.8} height={40} value={singleOrderData?.ORDNAME} />
              </Typography>

              <Typography variant="body2" >
                customer name: {singleOrderData?.CUSTNAME}
              </Typography>
              <Typography variant="body2" >
                country: {singleOrderData?.COUNTRYNAME}
              </Typography>
              <Typography variant="body2" >
                Details: {singleOrderData?.DETAILS}
              </Typography>
              {
                userinfo.userRoleName === 'Administrator' || userinfo.userRoleName === 'Shipper' ?
                  <Typography variant="body2" >
                    tracking Number [{singleOrderData?.shipRushStatus}]: {singleOrderData?.trackingNumber}

                  </Typography> : <></>
              }

            </CardContent>
          </Card>
          <Card sx={{ maxWidth: 600, padding: '2rem' }}>
            <Typography variant="h5" color="text.secondary">
              Remarks:
            </Typography>
            <Typography variant="body2" style={{ padding: '2rem' }}  >
              {singleOrderData?.ordertext}
            </Typography>


          </Card>
        </Stack>
        <>
          <Stack direction={'row'} spacing={2} alignItems={'center'}>
            {/* <Tooltip title="Picture">
              <IconButton aria-label="scan"
                size="large"
                style={{ color: 'black' }}
                onClick={() => handleClickOpenCamera()}>
                <CameraAltIcon fontSize="inherit" />
              </IconButton>
            </Tooltip> */}

            <Tooltip title="Save">
              <IconButton aria-label="scan"
                style={{ color: userinfo.userRoleName === 'Administrator' ? 'grey' : 'green' }}
                size="large"
                disabled={userinfo.userRoleName === 'Administrator' ? true : false}
                onClick={() => {
                  UpdateOrder(5, true) //complete
                }}>
                <SaveIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Pending">
              <IconButton aria-label="scan" size="large" style={{ color: 'red' }}
                onClick={() => UpdateOrder(6, true)}>
                <PendingActionsIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="In progress">
              <IconButton aria-label="scan" size="large" style={{ color: 'orange' }}
                onClick={() => UpdateOrder(2, true) // in progress                
                }>
                <PublishedWithChangesIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="orders">
              <IconButton aria-label="scan" size="large"
                onClick={() => navigate('/orders') // in progress                
                }>
                <ListAltTwoToneIcon fontSize="inherit" />
                {/* ForwardIcon */}
              </IconButton>
            </Tooltip>
            {userinfo.userRoleName === 'Shipper' ||
              userinfo.userRoleName === 'Administrator' ?
              <Tooltip title="shipRush" >
                <IconButton
                  //disabled = {singleOrderData?.taskStatus?.status === 'New' ? true : false}
                  aria-label="scan" size="large" style={{ color: '#0077b6' }}
                  onClick={() => SendToShipRush() // in progress                
                  }>
                  {/* <LocalShippingIcon fontSize="inherit" /> */}

                  <img src={logoShipRush} width="58" height="39" alt="ShipRus" />
                  {/* ForwardIcon */}
                </IconButton>
              </Tooltip>
              : <></>}
            {userinfo.userRoleName === 'Shipper' ||
              userinfo.userRoleName === 'Administrator' ?
              <Tooltip title="priority Sh" >
                <IconButton
                  //disabled = {singleOrderData?.taskStatus?.status === 'New' ? true : false}
                  aria-label="scan" size="large" style={{ color: '#0077b6' }}
                  onClick={() => SendToShipPrioritySh() // in progress                
                  }>
                  <img src="https://www.priority-software.com/wp-content/uploads/2023/02/logo.svg" width="58" height="38" alt="Priority" />
                  {/* ForwardIcon */}
                </IconButton>
              </Tooltip>
              : <></>}

            <TextField
              autoComplete='off'
              title='Sh number'
              placeholder="Sh number"
              id="outlined-basic"
              disabled={userinfo.userRoleName === "Shipper" ? false : true}
              autoFocus
              value={singleOrderData.ShData}
              onChange={_handleShDataChange}
            />
            <><h4>Pallet:</h4>
              <Checkbox

                checked={singleOrderData.Pallet === true ? true : false}
                name={'pallet'}
                onChange={_handlePalletChange}
              />
            </>


          </Stack>

          <Stack direction={'row'} spacing={30} justifyContent={'space-between'} >

            {singleOrderData.role?.role !== 'Shipper' ?
              <div className={!allowEdit ? 'divdisabled' : undefined}>
                <OrderBaskets />
              </div> : <></>
            }
            <div className={!allowEdit && userinfo.userRoleName !== 'Administrator' ? 'divdisabled' : undefined}>
              <OrderChat
                singleOrderData={singleOrderData}
                setSingleOrderData={setSingleOrderData}
              />
            </div>
          </Stack>

          {singleOrderData.role?.role === 'Shipper' ?
            <>
              <Stack direction={'row'} spacing={2} style={{ minWidth: '30%', alignContent: 'center' }}>
                <DialogContentText variant="h6">Assign Shipper</DialogContentText>
                <Select sx={{ width: '100%', color: 'black' }}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={newAssign}
                  //label="User"
                  name="userName"
                  onChange={event => setNewAssign(event.target.value)}
                >{
                    TaskUsers.filter((ts) => {
                      if (ts.userName !== "un assigned") return true; return false;
                    }).map((item, pos) => {
                      return (
                        <MenuItem key={pos} value={item.id}>
                          {item.userName}
                        </MenuItem>
                      )
                    })
                  }
                </Select>
                <Tooltip title="Assign ">
                  <IconButton aria-label="scan" size="large"
                    onClick={() => UpdateOrderChangeShipper() // in progress                
                    }>
                    <AssignmentIndIcon fontSize="inherit" />
                    {/* ForwardIcon */}
                  </IconButton>
                </Tooltip>
              </Stack>
            </>
            : <>,</>}
          <h2 style={{ color: 'red' }}>{allowEditAlertText}</h2>
        </>
        <div className={!allowEdit ? 'divdisabled' : undefined} >
          {showSpinner ?
            <LinearProgress /> : <></>}
          <CustomizedTables 
            singleOrderData={singleOrderData}
            setSingleOrderData={setSingleOrderData}
            allowEdit={allowEdit} 
            autoSaveSingleOrderData={UpdateOrder} />
          {userinfo.userRoleName === "Picker" || userinfo.userRoleName === "QC" ? <></> :
            <Box width={'96%'} display={'inline-grid'}>
              <PackedBoxesTable setBoxCount={setBoxCount} />
            </Box>
          }

          <Stack direction="row" spacing={2} >
            {singleOrderData.orderPhotoBase64 !== null && (
              <>
                <div >

                  <img style={{ maxWidth: '300px' }} src={singleOrderData.orderPhotoBase64} alt="Screenshot" />
                </div>
              </>
            )}
            {singleOrderData.orderPhotoBase64_1 !== null && (
              <>
                <div >

                  <img style={{ maxWidth: '300px' }} src={singleOrderData.orderPhotoBase64_1} alt="Screenshot" />
                </div>
              </>
            )}
            {singleOrderData.orderPhotoBase64_2 !== null && (
              <>
                <div >

                  <img style={{ maxWidth: '300px' }} src={singleOrderData.orderPhotoBase64_2} alt="Screenshot" />
                </div>
              </>
            )}
          </Stack>
        </div>
      </Box>


    </Container>
  )
}

export default OrderLines


